import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { Form, Button, FormGroup, Modal } from 'react-bootstrap';
import config from '../../config/config';
import RequestInfo from '../components/requestInfo/RequestInfo';
import CustomerContactInfo from '../components/customerContactInfo/CustomerContactInfo';
import ParticularOfVehicle from '../components/quotationPVComponent/particularOfVehicle/ParticularOfVehicle';
import ParticularOfMainDriver from '../components/quotationPVComponent/particularOfMainDriver/ParticularOfMainDriver';
import ParticularOfAdditionalDriver from '../components/quotationPVComponent/particularOfAdditionalDriver/ParticularOfAdditionalDriver';
import NcdEntitlementSumInsuredSection from '../components/quotationPVComponent/ncdEntitlementSumInsuredSection/NcdEntitlementSumInsuredSection';
import CoverageInformation from '../components/coverageInformation/CoverageInformation';
import CoverageTypeInfo from '../components/quotationPVComponent/coverageTypeInfo/CoverageTypeInfo';
import QuoteSummary from '../components/quoteSummary/QuoteSummary';
import UnderwritingQuestion from '../components/quotationPVComponent/underwritingQuestion/UnderwritingQuestion';
import ProgressBar from '../components/progressBar/ProgressBar';
import { numValidator } from '../utils/validator';
import { todayMomentISOString, quotationTodayAdd1Year, momentToISOString, quotationMomentAdd1Year, momentSetHKTimezone } from '../../utils/dateUtils';

const moment = require('moment');
const async = require('async');

const appUrlPath = `/${config.appUrlPath}`;

/* eslint no-underscore-dangle: ["error", { "allow": ["_isAMomentObject"] }] */
export class PVForm extends Component {
  constructor(props) {
    super(props);
    const role = localStorage.getItem('role');
    const agentCode = role === 'agent' ? localStorage.getItem('agentCode') : '';
    const agentName = role === 'agent' ? localStorage.getItem('displayName') : '';

    this.state = {
      redirect: false,
      option: [],
      role,
      errorMsg: [],
      showModal: false,
      count: 0,
      isLoading: false,
      validSubmit: true,
      mainDriverValidSubmit: true,
      additionalDriverValidSubmit: true,
      isValidCreateDriver: false,
      quotationNo: '',
      pv: {
        requestInfo: {
          agentCode,
          agentName,
          proposerType: 'Individual',
          quotationNo: '',
          insuredName: '',
          quotationDate: todayMomentISOString(),
          id: ''
        },
        custContactInfo: {
          contactPerson: '',
          proposerType: 'Individual',
          address: '',
          postalCode: '',
          country: 'HONG KONG',
          homeTel: '',
          officeTel: '',
          mobile: '',
          fax: '',
          email: ''
        },
        particularOfVehicle: {
          make: '',
          model: '',
          vehicleGroup: '',
          cubicCap: '',
          seatingCap: '',
          yearOfManufacture: '',
          vehicleRegNo: ''
        },
        particularOfMainDriver: {
          nameFormat: 'surnameGivenName',
          surname: '',
          givenName: '',
          drivingExperience: '',
          ageRange: '',
          maritalStatus: 'Single',
          sex: 'male',
          noOfClaimsInPast3Years: '',
          totalClaimAmountInPast3Years: '',
          occupation: '',
          nationality: 'HONG KONG',
          ncdEntitlement: '0',
          sumInsured: ''
        },
        particularOfAdditionalDriver: [

        ],
        coverageInfo: {
          coveragePeriodFrom: todayMomentISOString(),
          coveragePeriodTo: quotationTodayAdd1Year(),
          mainCoverType: {
            comprehensive: {
              checked: true,
              grossPremium: 0,
              netPremium: 0
            },
            thirdParty: {
              checked: false,
              grossPremium: 0,
              netPremium: 0
            }
          }
        },
        underwritingQuestion: {
          q1: {
            checked: false,
            details: ''
          },
          q2: {
            checked: false,
            details: ''
          },
          q3: {
            checked: false,
            details: ''
          },
          q4: {
            checked: false,
            details: ''
          },
          q5: {
            checked: false,
            details: ''
          },
          q6: {
            checked: true,
            details: ''
          }
        },
        grossPremium: 0,
        netPremium: 0,
        mib: 0,
        levy: 0,
        premiumPayable: 0,
        caseStatus: 'pending',
        type: 'pv'
      }
    };

    this.handleChangeRequestInfo = this.handleChangeRequestInfo.bind(this);
    this.handleChangeCustContactInfo = this.handleChangeCustContactInfo.bind(this);
    this.handleChangeParticularOfVehicle = this.handleChangeParticularOfVehicle.bind(this);
    this.handleChangeParticularOfMainDriver = this.handleChangeParticularOfMainDriver.bind(this);
    this.handleChangeParticularOfAdditionalDriver = this.handleChangeParticularOfAdditionalDriver.bind(this);
    this.handleChangeCoverageInfoPreviousFrom = this.handleChangeCoverageInfoPreviousFrom.bind(this);
    this.handleChangeCoverageInfoPreviousTo = this.handleChangeCoverageInfoPreviousTo.bind(this);
    this.handleChangeMainCoverageType = this.handleChangeMainCoverageType.bind(this);
    this.handleChangeUnderwritingQuestion = this.handleChangeUnderwritingQuestion.bind(this);
    this.handleGetAgentName = this.handleGetAgentName.bind(this);
    this.handleChangeAgentCode = this.handleChangeAgentCode.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.optionChange = this.optionChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.createDriver = this.createDriver.bind(this);
    this.removeDriver = this.removeDriver.bind(this);
    this.close = this.close.bind(this);

    this.calculator = this.calculator.bind(this);
    this.calculationAmount = this.calculationAmount.bind(this);

    this.resetComprehensiveOrThirdParty = this.resetComprehensiveOrThirdParty.bind(this);
    this.handleSubmitType = this.handleSubmitType.bind(this)
    this.validationOnSubmit = this.validationOnSubmit.bind(this);
    this.validationMainDriverOccupationAndNationality = this.validationMainDriverOccupationAndNationality.bind(this);
    this.validationAdditionalDriverOccupationAndNationality = this.validationAdditionalDriverOccupationAndNationality.bind(this);
    this.validationOnCreateDriver = this.validationOnCreateDriver.bind(this);
  }

  componentWillMount() {
    // Check the access
    async.series([
      (callback) => {
        axios.get(`${appUrlPath}/getCsrfToken`, {
          params: {},
          headers: { 'ACTION-LOG': 'Access PV Form Page' }
        })
        .then((res) => {
          axios.defaults.headers.common = {
            'CSRF-TOKEN': res.data.csrfToken
          };
          callback();
        })
        .catch(() => {
          callback();
        });
      },
      (callback) => {
        this.setState({ isLoading: true })
        callback();
      },
      (callback) => {
        const quotationNo = window.location.search.substr(1).split('=')[1]
        if (!quotationNo) {
          if (this.props.location.state && this.props.location.state.isAgree) {
            axios.get(`${appUrlPath}/generateQuotationNoPV`, {
              params: {}
            })
            .then((res) => {
              const requestInfo = { ...this.state.pv.requestInfo };
              requestInfo.quotationNo = res.data.quotationNo;
              this.setState({ pv: { ...this.state.pv, requestInfo } }, () => {
                this.setState({ isLoading: false })
              });
            })
            .catch(() => {
            });
          } else {
            window.location = '/en/motorb2b/home';
          }
        } else {
          axios.get(`${appUrlPath}/getPVQuotationByNum`, {
            params: {
              quotationNo,
            }
          })
          .then((res) => {
            this.setState({ pv: res.data }, () => {
              this.optionChange();
              this.setState({ isLoading: false, count: res.data.particularOfAdditionalDriver.length });
              this.validationOnCreateDriver()
              this.validationOnSubmit(true)
            });
          })
          .catch(() => {
          });
        }
        callback();
      }
    ], () => {

    });
  }

  handleChangeRequestInfo(e) {
    if (e != null) {
      const requestInfo = { ...this.state.pv.requestInfo };
      if (e._isAMomentObject) {
        requestInfo.quotationDate = e.toDate();
      } else if (e.target.id === 'quotationNo') {
        requestInfo.quotationNo = e.target.value;
      } else if (e.target.id === 'idNo') {
        requestInfo.id = e.target.value;
      } else if (e.target.name === 'proposerType') {
        requestInfo.proposerType = e.target.value;
      } else if (e.target.id === 'insuredName') {
        requestInfo.insuredName = e.target.value;
      }
      this.setState({ pv: { ...this.state.pv, requestInfo } });
    }
  }

  handleChangeCustContactInfo(e) {
    const custContactInfo = { ...this.state.pv.custContactInfo };
    if (e.target.id === 'contactPerson') {
      custContactInfo.contactPerson = e.target.value;
    } else if (e.target.id === 'homeTel') {
      custContactInfo.homeTel = e.target.value;
    } else if (e.target.id === 'address') {
      custContactInfo.address = e.target.value;
    } else if (e.target.id === 'officeTel') {
      custContactInfo.officeTel = e.target.value;
    } else if (e.target.id === 'mobile') {
      custContactInfo.mobile = e.target.value;
    } else if (e.target.id === 'postalCode') {
      custContactInfo.postalCode = e.target.value;
    } else if (e.target.id === 'fax') {
      custContactInfo.fax = e.target.value;
    } else if (e.target.id === 'email') {
      custContactInfo.email = e.target.value;
    } else if (e.target.id === 'country') {
      custContactInfo.country = e.target.value;
    } else if (e.target.name === 'cusProposerType') {
      custContactInfo.proposerType = e.target.value;
    }
    this.setState({ pv: { ...this.state.pv, custContactInfo } });
  }

  handleChangeParticularOfVehicle(e) {
    const particularOfVehicle = { ...this.state.pv.particularOfVehicle };
    let isMakeChange = false;
    let isModelChange = false;
    let isYOMChange = false;
    if (e.target.id === 'make') {
      particularOfVehicle.make = e.target.value;
      particularOfVehicle.model = '';
      particularOfVehicle.vehicleGroup = '';
      isMakeChange = true;
    } else if (e.target.id === 'model') {
      particularOfVehicle.model = e.target.value;
      isModelChange = true;
    } else if (e.target.id === 'cubicCap') {
      if (numValidator(e.target.value)) {
        particularOfVehicle.cubicCap = Number(e.target.value);
      }
    } else if (e.target.id === 'seatingCap') {
      if (numValidator(e.target.value)) {
        particularOfVehicle.seatingCap = Number(e.target.value);
      }
    } else if (e.target.name === 'yearOfManufacture') {
      if (numValidator(e.target.value)) {
        particularOfVehicle.yearOfManufacture = e.target.value;
        isYOMChange = true;
      }
    } else if (e.target.id === 'vehicleRegNo') {
      particularOfVehicle.vehicleRegNo = e.target.value;
    }

    this.setState({ pv: { ...this.state.pv, particularOfVehicle } }, () => {
      if (isMakeChange) { this.optionChange(); }
      if (isModelChange) { this.handleVehicleGroup(); }
      if (isYOMChange) { this.calculator(); }
    });
  }

  handleChangeParticularOfMainDriver(e) {
    const particularOfMainDriver = { ...this.state.pv.particularOfMainDriver };
    let isOccupationChange = false;
    let isNationalityChange = false;
    let isNcdChange = false;
    if (e.target.name === 'nameFormat') {
      particularOfMainDriver.nameFormat = e.target.value;
    } else if (e.target.name === 'surname') {
      particularOfMainDriver.surname = e.target.value;
    } else if (e.target.name === 'givenName') {
      particularOfMainDriver.givenName = e.target.value;
    } else if (e.target.name === 'drivingExperience') {
      particularOfMainDriver.drivingExperience = e.target.value;
    } else if (e.target.name === 'ageRange') {
      particularOfMainDriver.ageRange = e.target.value;
    } else if (e.target.name === 'maritalStatus') {
      particularOfMainDriver.maritalStatus = e.target.value;
    } else if (e.target.name === 'sex') {
      particularOfMainDriver.sex = e.target.value;
    } else if (e.target.name === 'noOfClaimsInPast3Years') {
      if (numValidator(e.target.value)) {
        particularOfMainDriver.noOfClaimsInPast3Years = Number(e.target.value);
      }
    } else if (e.target.name === 'totalClaimAmountInPast3Years') {
      if (numValidator(e.target.value)) {
        particularOfMainDriver.totalClaimAmountInPast3Years = Number(e.target.value);
      }
    } else if (e.target.name === 'occupation') {
      particularOfMainDriver.occupation = e.target.value;
      isOccupationChange = true;
    } else if (e.target.name === 'nationality') {
      particularOfMainDriver.nationality = e.target.value;
      isNationalityChange = true;
    } else if (e.target.name === 'ncdEntitlement') {
      particularOfMainDriver.ncdEntitlement = e.target.value;
      isNcdChange = true;
    } else if (e.target.name === 'sumInsured') {
      if (numValidator(e.target.value)) {
        particularOfMainDriver.sumInsured = e.target.value;
      }
    }

    this.setState({ pv: { ...this.state.pv, particularOfMainDriver } }, () => {
      this.validationOnCreateDriver();
      if (isOccupationChange) { this.validationMainDriverOccupationAndNationality('occupation'); }
      if (isNationalityChange) { this.validationMainDriverOccupationAndNationality('nationality'); }
      if (isNcdChange) { this.calculator() }
    });
  }

  validationMainDriverOccupationAndNationality(type) {
    const pvForm = this.state.pv;
    let occupation = pvForm.particularOfMainDriver.occupation;
    const nationality = pvForm.particularOfMainDriver.nationality;
    let occupationValid = true;
    let nationalityValid = true;

    if (!occupation) {
      occupation = '-9999';
    }

    axios.post(`${appUrlPath}/getOccupationReferralPV`, {
      occupation
    })
    .then((res) => {
      if (res.data.referral === true) {
        occupationValid = false;
      }
      if (nationality && nationality !== 'HONG KONG') {
        nationalityValid = false;
      }

      if (occupationValid && nationalityValid) {
        this.setState({ mainDriverValidSubmit: true });
      } else {
        let errorMsg = '';
        if (!occupationValid && type === 'occupation') {
          errorMsg = 'This is a referral / declined risk. Please refer to your account executive. (Occupation)';
        } else if (!nationalityValid && type === 'nationality') {
          errorMsg = 'This is a referral / declined risk. Please refer to your account executive. (Nationality)';
        }
        if (errorMsg) {
          this.setState({ mainDriverValidSubmit: false, errorMsg: [errorMsg], showModal: true });
        }
      }
    });
  }

  handleChangeParticularOfAdditionalDriver(id, e) {
    const particularOfAdditionalDriver = this.state.pv.particularOfAdditionalDriver.slice()
    let isOccupationChange = false;
    let isNationalityChange = false;
    if (e.target.name === 'nameFormat') {
      particularOfAdditionalDriver[id].nameFormat = e.target.value;
    } else if (e.target.name === 'surname') {
      particularOfAdditionalDriver[id].surname = e.target.value;
    } else if (e.target.name === 'givenName') {
      particularOfAdditionalDriver[id].givenName = e.target.value;
    } else if (e.target.name === 'drivingExperience') {
      particularOfAdditionalDriver[id].drivingExperience = e.target.value;
    } else if (e.target.name === 'ageRange') {
      particularOfAdditionalDriver[id].ageRange = e.target.value;
    } else if (e.target.name === 'maritalStatus') {
      particularOfAdditionalDriver[id].maritalStatus = e.target.value;
    } else if (e.target.name === 'sex') {
      particularOfAdditionalDriver[id].sex = e.target.value;
    } else if (e.target.name === 'noOfClaimsInPast3Years') {
      particularOfAdditionalDriver[id].noOfClaimsInPast3Years = Number(e.target.value);
    } else if (e.target.name === 'totalClaimAmountInPast3Years') {
      particularOfAdditionalDriver[id].totalClaimAmountInPast3Years = Number(e.target.value);
    } else if (e.target.name === 'occupation') {
      particularOfAdditionalDriver[id].occupation = e.target.value;
      isOccupationChange = true;
    } else if (e.target.name === 'nationality') {
      particularOfAdditionalDriver[id].nationality = e.target.value;
      isNationalityChange = true;
    } else if (e.target.name === 'relationshipWithPolicyholder') {
      particularOfAdditionalDriver[id].relationshipWithPolicyholder = e.target.value;
    }

    this.setState({ pv: { ...this.state.pv, particularOfAdditionalDriver } }, () => {
      this.validationOnCreateDriver();
      if (isOccupationChange) { this.validationAdditionalDriverOccupationAndNationality(particularOfAdditionalDriver[id], 'occupation'); }
      if (isNationalityChange) { this.validationAdditionalDriverOccupationAndNationality(particularOfAdditionalDriver[id], 'nationality'); }
    })
  }

  validationAdditionalDriverOccupationAndNationality(driver, type) {
    let occupation = driver.occupation;
    const nationality = driver.nationality;
    let occupationValid = true;
    let nationalityValid = true;

    if (!occupation) {
      occupation = '-9999';
    }

    axios.post(`${appUrlPath}/getOccupationReferralPV`, {
      occupation
    })
    .then((res) => {
      if (res.data.referral === true) {
        occupationValid = false;
      }
      if (nationality && nationality !== 'HONG KONG') {
        nationalityValid = false;
      }

      if (occupationValid && nationalityValid) {
        this.setState({ additionalDriverValidSubmit: true });
      } else {
        let errorMsg = '';
        if (!occupationValid && type === 'occupation') {
          errorMsg = 'This is a referral / declined risk. Please refer to your account executive. (Occupation)';
        } else if (!nationalityValid && type === 'nationality') {
          errorMsg = 'This is a referral / declined risk. Please refer to your account executive. (Nationality)';
        }
        if (errorMsg) {
          this.setState({ additionalDriverValidSubmit: false, errorMsg: [errorMsg], showModal: true });
        }
      }
    });
  }

  handleChangeCoverageInfoPreviousFrom(e) {
    const coverageInfo = { ...this.state.pv.coverageInfo };
    if (e != null && e._isAMomentObject) {
      coverageInfo.coveragePeriodFrom = momentToISOString(e);
      coverageInfo.coveragePeriodTo = quotationMomentAdd1Year(e);
    } else {
      coverageInfo.coveragePeriodTo = null
    }

    this.setState({ pv: { ...this.state.pv, coverageInfo } }, () => {
      this.calculator();
    });
  }

  handleChangeCoverageInfoPreviousTo(e) {
    const coverageInfo = { ...this.state.pv.coverageInfo };
    coverageInfo.coveragePeriodTo = momentToISOString(e);
    this.setState({ pv: { ...this.state.pv, coverageInfo } });
  }

  handleSave(event) {
    event.preventDefault();
    const no = window.location.search.substr(1).split('=')[1]
    let isNewPv = false;
    if (!no) {
      isNewPv = true
    }
    if (this.state.typeOfSubmit === 'save') {
      this.setState({ isLoading: true });
      const pv = { ...this.state.pv };
      const coverageFrom = pv.coverageInfo.coveragePeriodFrom;
      if (coverageFrom) {
        const isSameOrAfterToday = momentSetHKTimezone(coverageFrom).isSameOrAfter(moment(), 'day')
        if (!isSameOrAfterToday) {
          this.setState({ errorMsg: ['Please update coverage period'], showModal: true, isLoading: false });
          return;
        }
      }
      axios.post(`${appUrlPath}/pvSave`, {
        pv: this.state.pv,
        isNewPv
      })
      .then((response) => {
        const responsePv = response.data
        const msg = `The quotation number ${this.state.pv.requestInfo.quotationNo} is successfully saved.`;
        this.setState({ isLoading: false, pv: responsePv, errorMsg: [msg], showModal: true });
      })
      .catch((error) => {
        let errorMsg = '';
        if (error.response) {
          errorMsg = error.response.data; 
        }
        this.setState({ isLoading: false, errorMsg: [errorMsg], showModal: true });
      });
    } else if (this.state.typeOfSubmit === 'saveQuote') {
      this.setState({ isLoading: true });// For loading mask
      const pv = { ...this.state.pv };
      const coverageFrom = pv.coverageInfo.coveragePeriodFrom;
      if (coverageFrom) {
        const isSameOrAfterToday = momentSetHKTimezone(coverageFrom).isSameOrAfter(moment(), 'day')
        if (!isSameOrAfterToday) {
          this.setState({ errorMsg: ['Please update coverage period'], showModal: true, isLoading: false });
          return;
        }
      }
      axios.post(`${appUrlPath}/pvSaveAndQuote`, {
        pv: this.state.pv,
        isNewPv
      }, { responseType: 'arraybuffer' })
      .then((response) => {
        const msg = `The quotation number ${this.state.pv.requestInfo.quotationNo} is successfully saved.`;
        this.setState({ isLoading: false, errorMsg: [msg], showModal: true });

        const file = new Blob([response.data], { type: 'application/pdf' });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // IE
          window.navigator.msSaveOrOpenBlob(file, 'Quotation.pdf');
        } else {
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL, '_blank');
        }
      })
      .catch((error) => {
        let errorMsg = '';
        if (error.response) {
          errorMsg = error.response.data; 
        }
        this.setState({ isLoading: false, errorMsg: [errorMsg], showModal: true });
      });
    }
  }

  close() {
    this.setState({ showModal: false });
  }

  handleClick(e) {
    e.preventDefault();
    window.location.assign('/en/motorb2b/home');
  }

  handleChangeAgentCode(e) {
    const requestInfo = { ...this.state.pv.requestInfo };
    const agentCode = e.target.value;
    requestInfo.agentCode = agentCode
    this.setState({ pv: { ...this.state.pv, requestInfo } });
  }

  handleGetAgentName(e) {
    const requestInfo = { ...this.state.pv.requestInfo };
    const agentCode = e.target.value;
    axios.post(`${appUrlPath}/getAgentNameByAgentCode`, {
      agentCode
    })
    .then((res) => {
      requestInfo.agentName = res.data.agentName
      this.setState({ pv: { ...this.state.pv, requestInfo } });
    });
  }

  optionChange() {
    axios.get(`${appUrlPath}/getModel`, {
      params: { 'make': this.state.pv.particularOfVehicle.make }
    })
    .then((res) => {
      this.setState({ option: res.data });
    })
    .catch(() => {

    });
  }

  handleVehicleGroup() {
    axios.get(`${appUrlPath}/getVehicleGroup`, {
      params: {
        'make': this.state.pv.particularOfVehicle.make,
        'model': this.state.pv.particularOfVehicle.model
      }
    })
    .then((res) => {
      const vehicleGroup = res.data.vehicleGroup;
      const cc = res.data.cc;
      const particularOfVehicle = { ...this.state.pv.particularOfVehicle };

      particularOfVehicle.vehicleGroup = vehicleGroup;
      particularOfVehicle.cubicCap = cc;
      this.setState({ pv: { ...this.state.pv, particularOfVehicle } }, () => {
        this.calculator();
      });
    })
    .catch(() => {

    });
  }

  handleChangeMainCoverageType(e) {
    const mainCoverType = { ...this.state.pv.coverageInfo.mainCoverType };
    if (e.target.value === 'comprehensive') {
      mainCoverType.comprehensive.checked = true;
      mainCoverType.thirdParty.checked = false;
      this.resetComprehensiveOrThirdParty('thirdParty')
    } else if (e.target.value === 'thirdParty') {
      mainCoverType.thirdParty.checked = true;
      mainCoverType.comprehensive.checked = false;
      this.resetComprehensiveOrThirdParty('comprehensive')
    }

    this.setState({ pv: { ...this.state.pv, mainCoverType } }, () => {
      this.calculator();
    });
  }

  handleChangeUnderwritingQuestion(e) {
    const underwritingQuestion = { ...this.state.pv.underwritingQuestion };
    if (e.target.name === 'question1') {
      underwritingQuestion.q1.checked = e.target.value === 'true';
    } else if (e.target.id === 'question1') {
      underwritingQuestion.q1.details = e.target.value
    } else if (e.target.name === 'question2') {
      underwritingQuestion.q2.checked = e.target.value === 'true';
    } else if (e.target.id === 'question2') {
      underwritingQuestion.q2.details = e.target.value
    } else if (e.target.name === 'question3') {
      underwritingQuestion.q3.checked = e.target.value === 'true';
    } else if (e.target.id === 'question3') {
      underwritingQuestion.q3.details = e.target.value
    } else if (e.target.name === 'question4') {
      underwritingQuestion.q4.checked = e.target.value === 'true';
    } else if (e.target.id === 'question4') {
      underwritingQuestion.q4.details = e.target.value
    } else if (e.target.name === 'question5') {
      underwritingQuestion.q5.checked = e.target.value === 'true';
    } else if (e.target.id === 'question5') {
      underwritingQuestion.q5.details = e.target.value
    } else if (e.target.name === 'question6') {
      underwritingQuestion.q6.checked = e.target.value === 'true';
    } else if (e.target.id === 'question6') {
      underwritingQuestion.q6.details = e.target.value
    }
    this.setState({ pv: { ...this.state.pv, underwritingQuestion } }, () => {
      this.validationOnSubmit(true)
    });
  }

  createDriver(e) {
    e.preventDefault();
    this.setState((prevState) => {
      return { count: prevState.count + 1 }
    });
    const tmpDriver = {
      itemId: this.state.count,
      nameFormat: 'surnameGivenName',
      surname: '',
      givenName: '',
      drivingExperience: '',
      ageRange: '',
      maritalStatus: 'Single',
      sex: '',
      noOfClaimsInPast3Years: '',
      totalClaimAmountInPast3Years: '',
      occupation: '',
      nationality: 'HONG KONG',
      relationshipWithPolicyholder: ''
    }
    const particularOfAdditionalDriver = this.state.pv.particularOfAdditionalDriver.slice()
    particularOfAdditionalDriver.push(tmpDriver)
    this.setState({ pv: { ...this.state.pv, particularOfAdditionalDriver } }, () => {
      this.validationOnCreateDriver()
    })
  }

  removeDriver(e) {
    e.preventDefault();
    this.setState((prevState) => {
      return { count: prevState.count - 1 }
    });
    const oldArray = this.state.pv.particularOfAdditionalDriver.slice();
    oldArray.pop();
    const particularOfAdditionalDriver = oldArray;
    this.setState({ pv: { ...this.state.pv, particularOfAdditionalDriver } }, () => {
      this.validationOnCreateDriver()
    })
  }

  calculator() {
    if (this.state.pv.coverageInfo.mainCoverType.comprehensive.checked) {
      this.calculationAmount('comprehensive');
    } else if (this.state.pv.coverageInfo.mainCoverType.thirdParty.checked) {
      this.calculationAmount('thirdParty');
    }
  }

  calculationAmount(type) {
    const pvForm = this.state.pv;
    const vehicleGroup = pvForm.particularOfVehicle.vehicleGroup;
    const yearOfManufacture = pvForm.particularOfVehicle.yearOfManufacture;
    const ncdEntitlement = pvForm.particularOfMainDriver.ncdEntitlement;
    const mainDriverAge = pvForm.particularOfMainDriver.ageRange;

    let isValidOtherDriverAge = true;
    for (let i = 0; i < pvForm.particularOfAdditionalDriver.length; i++) {
      const otherDriverAge = pvForm.particularOfAdditionalDriver[i].ageRange;
      if (!otherDriverAge) {
        isValidOtherDriverAge = false;
        break;
      }
    }

    const isValidSubmit = this.validationOnSubmit(true);

    if (vehicleGroup && yearOfManufacture && mainDriverAge && isValidOtherDriverAge
        && ncdEntitlement && isValidSubmit) {
      axios.post(`${appUrlPath}/calculatePVQuotation`, {
        pv: pvForm,
        type
      })
      .then((res) => {
        this.setState({ pv: res.data.result });
      })
      .catch(() => {
        this.setState({ errorMsg: ['Calculation Error.'], showModal: true });
      });
    } else {
      this.resetComprehensiveOrThirdParty('comprehensive')
      this.resetComprehensiveOrThirdParty('thirdParty')
    }
  }

  resetComprehensiveOrThirdParty(type) {
    const mainCoverType = { ...this.state.pv.coverageInfo.mainCoverType };
    if (type === 'comprehensive') {
      mainCoverType.comprehensive.grossPremium = 0;
      mainCoverType.comprehensive.netPremium = 0;
    } else if (type === 'thirdParty') {
      mainCoverType.thirdParty.grossPremium = 0;
      mainCoverType.thirdParty.netPremium = 0;
    }

    const pv = { ...this.state.pv };

    pv.grossPremium = 0
    pv.netPremium = 0
    pv.mib = 0
    pv.levy = 0
    pv.premiumPayable = 0

    this.setState({ pv: { ...this.state.pv, mainCoverType } });
    this.setState({ pv });
  }

  validationOnCreateDriver() {
    let isValidCreateDriver = false;
    const particularOfMainDriver = this.state.pv.particularOfMainDriver;
    const particularOfAdditionalDriver = this.state.pv.particularOfAdditionalDriver;
    if (particularOfMainDriver.drivingExperience && particularOfMainDriver.ageRange
        && particularOfMainDriver.noOfClaimsInPast3Years.toString() && particularOfMainDriver.totalClaimAmountInPast3Years.toString()
        && particularOfMainDriver.occupation && particularOfMainDriver.sex
        && particularOfMainDriver.nationality) {
      isValidCreateDriver = true
    } else {
      isValidCreateDriver = false
      this.setState({ isValidCreateDriver })
      return;
    }

    if (particularOfAdditionalDriver.length > 0) {
      for (let i = 0; i < particularOfAdditionalDriver.length; i++) {
        const driver = particularOfAdditionalDriver[i]
        if (driver.drivingExperience && driver.ageRange
            && driver.noOfClaimsInPast3Years.toString() && driver.totalClaimAmountInPast3Years.toString()
            && driver.occupation && driver.sex
            && driver.nationality) {
          isValidCreateDriver = true;
        } else {
          isValidCreateDriver = false;
          break;
        }
      }
    }
    this.setState({ isValidCreateDriver })
  }

  validationOnSubmit(showAlert) {
    const type = ['noOfClaims', 'totalClaimAmount', 'vehicleRegNo', 'yearOfManufacture', 'vehicleGroup', 'ageRange', 'drivingExperience', 'sumInsured', 'underwritingQuestion']
    let validSubmit = this.state.validSubmit;
    const pvForm = this.state.pv;
    const comprehensive = pvForm.coverageInfo.mainCoverType.comprehensive;
    const thirdParty = pvForm.coverageInfo.mainCoverType.thirdParty;
    const errorMsg = [];

    let isValid = true;
    let check = true;

    for (let i = 0; i < type.length && check; i++) {
      const typeValue = type[i]
      if (typeValue === 'noOfClaims') {
        const mainDriverNoOfClaims = pvForm.particularOfMainDriver.noOfClaimsInPast3Years;
        const mainDriverTotalClaimAmount = pvForm.particularOfMainDriver.totalClaimAmountInPast3Years;
        if (pvForm.particularOfAdditionalDriver.length > 0) {
          for (let j = 0; j < pvForm.particularOfAdditionalDriver.length && check; j++) {
            const noOfClaims = pvForm.particularOfAdditionalDriver[j].noOfClaimsInPast3Years;
            const totalClaimAmount = pvForm.particularOfAdditionalDriver[j].totalClaimAmountInPast3Years;
            if (noOfClaims && noOfClaims > 0) {
              errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (No of claims - Additional Driver)\n')
              validSubmit = false;
              isValid = false;
              check = false;
            } else if (totalClaimAmount && totalClaimAmount > 0 && noOfClaims === 0) {
              errorMsg.push('Inconsistent claim number and claim amount\n')
              validSubmit = false;
              isValid = false;
              check = false;
            } else {
              validSubmit = true;
              isValid = true;
            }
          }
        }

        if (check) {
          if (mainDriverNoOfClaims && mainDriverNoOfClaims > 0) {
            errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (No of claims - Main Driver)\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else if (mainDriverTotalClaimAmount && mainDriverTotalClaimAmount > 0 &&
              mainDriverNoOfClaims === 0) {
            errorMsg.push('Inconsistent claim number and claim amount\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }
      }

      if (typeValue === 'totalClaimAmount') {
        const mainDriverNoOfClaims = pvForm.particularOfMainDriver.noOfClaimsInPast3Years;
        const mainDriverTotalClaimAmount = pvForm.particularOfMainDriver.totalClaimAmountInPast3Years;
        if (pvForm.particularOfAdditionalDriver.length > 0) {
          for (let j = 0; j < pvForm.particularOfAdditionalDriver.length && check; j++) {
            const noOfClaims = pvForm.particularOfAdditionalDriver[j].noOfClaimsInPast3Years;
            const totalClaimAmount = pvForm.particularOfAdditionalDriver[j].totalClaimAmountInPast3Years;
            if (totalClaimAmount && totalClaimAmount > 0 && noOfClaims === 0) {
              errorMsg.push('Inconsistent claim number and claim amount\n')
              validSubmit = false;
              isValid = false;
              check = false
            } else {
              validSubmit = true;
              isValid = true;
            }
          }
        }

        if (check) {
          if (mainDriverTotalClaimAmount && mainDriverTotalClaimAmount > 0 && mainDriverNoOfClaims === 0) {
            errorMsg.push('Inconsistent claim number and claim amount\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }
      }

      if (typeValue === 'drivingExperience') {
        const mainDriverDrivingExperience = pvForm.particularOfMainDriver.drivingExperience;
        const addDriverDrivingExperienceArray = []
        if (pvForm.particularOfAdditionalDriver.length > 0) {
          for (let j = 0; j < pvForm.particularOfAdditionalDriver.length; j++) {
            addDriverDrivingExperienceArray.push(pvForm.particularOfAdditionalDriver[j].drivingExperience)
          }
        }

        for (let j = 0; j < addDriverDrivingExperienceArray.length && check; j++) {
          if (addDriverDrivingExperienceArray[j] && addDriverDrivingExperienceArray[j] < 2) {
            errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Driving Experience - Additional Driver)\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }

        if (check) {
          if (mainDriverDrivingExperience && mainDriverDrivingExperience < 2) {
            errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Driving Experience - Main Driver)\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }
      }

      if (typeValue === 'underwritingQuestion') {
        const q1 = this.state.pv.underwritingQuestion.q1;
        const q2 = this.state.pv.underwritingQuestion.q2;
        const q3 = this.state.pv.underwritingQuestion.q3;
        const q5 = this.state.pv.underwritingQuestion.q5;
        const q6 = this.state.pv.underwritingQuestion.q6;

        if (check) {
          if (q1.checked || q2.checked || q3.checked || q5.checked || !q6.checked) {
            errorMsg.push('Please contact us for referral case.\n')
            validSubmit = false
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }
      }

      if (typeValue === 'vehicleGroup') {
        const vehicleGroup = pvForm.particularOfVehicle.vehicleGroup
        if (check) {
          if (comprehensive.checked) {
            if (vehicleGroup === '30' || vehicleGroup === '98' || vehicleGroup === '99') {
              errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Make and Model)\n');
              validSubmit = false;
              isValid = false
              check = false;
            } else {
              validSubmit = true;
              isValid = true
            }
          } else if (thirdParty.checked) {
            if (vehicleGroup === '98' || vehicleGroup === '99') {
              errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Make and Model)\n');
              validSubmit = false;
              isValid = false
              check = false;
            } else {
              validSubmit = true;
              isValid = true
            }
          }
        }
      }

      if (typeValue === 'yearOfManufacture') {
        if (check) {
          if (comprehensive.checked) {
            const yearOfManufacture = pvForm.particularOfVehicle.yearOfManufacture;
            if (yearOfManufacture) {
              const vehicleAge = moment(pvForm.coverageInfo.coveragePeriodFrom).year() - yearOfManufacture;
              if (vehicleAge > 10) {
                errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Year of Manufacture) (For comprehensive plan, vehicle age > 10 requires referral or you could select Third Party at bottom)\n')
                validSubmit = false;
                isValid = false;
                check = false;
              } else if (vehicleAge < 0) {
                errorMsg.push('Vehicle age (inception year - manufacture year) must >= 0.\n')
                validSubmit = false;
                isValid = false;
                check = false;
              } else {
                validSubmit = true;
                isValid = true;
              }
            }
          } else if (thirdParty.checked) {
            const yearOfManufacture = pvForm.particularOfVehicle.yearOfManufacture;
            if (yearOfManufacture) {
              const vehicleAge = moment(pvForm.coverageInfo.coveragePeriodFrom).year() - yearOfManufacture;
              if (vehicleAge > 15) {
                errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Year of Manufacture) (For comprehensive plan, vehicle age > 10 requires referral or you could select Third Party at bottom)\n')
                validSubmit = false;
                isValid = false;
                check = false;
              } else if (vehicleAge < 0) {
                errorMsg.push('Vehicle age (inception year - manufacture year) must >= 0.\n')
                validSubmit = false;
                isValid = false;
                check = false;
              } else {
                validSubmit = true;
                isValid = true;
              }
            }
          }
        }
      }

      if (typeValue === 'ageRange') {
        const mainDriverAgeRange = pvForm.particularOfMainDriver.ageRange;
        const addDriverAgeRangeArray = []
        if (pvForm.particularOfAdditionalDriver.length > 0) {
          for (let j = 0; j < pvForm.particularOfAdditionalDriver.length; j++) {
            addDriverAgeRangeArray.push(pvForm.particularOfAdditionalDriver[j].ageRange)
          }
        }

        for (let j = 0; j < addDriverAgeRangeArray.length && check; j++) {
          if (addDriverAgeRangeArray[j] && (addDriverAgeRangeArray[j] < 25 || addDriverAgeRangeArray[j] > 70)) {
            errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Age - Additional Driver)\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }

        if (check) {
          if (mainDriverAgeRange && (mainDriverAgeRange < 25 || mainDriverAgeRange > 70)) {
            errorMsg.push('This is a referral / declined risk. Please refer to your account executive. (Age - Main Driver)\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
            isValid = true;
          }
        }
      }

      if (typeValue === 'vehicleRegNo') {
        const vehicleRegNo = pvForm.particularOfVehicle.vehicleRegNo;
        if (check) {
          if (vehicleRegNo.indexOf('I') !== -1 ||
              vehicleRegNo.indexOf('O') !== -1 ||
              vehicleRegNo.indexOf('Q') !== -1 ||
              vehicleRegNo.indexOf('i') !== -1 ||
              vehicleRegNo.indexOf('o') !== -1 ||
              vehicleRegNo.indexOf('q') !== -1) {
            errorMsg.push('Invalid registration mark\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
          }
        }
      }

      if (typeValue === 'sumInsured') {
        const sumInsured = pvForm.particularOfMainDriver.sumInsured;
        if (check) {
          if (sumInsured < 0) {
            errorMsg.push('Invalid Sum Insured\n')
            validSubmit = false;
            isValid = false;
            check = false;
          } else {
            validSubmit = true;
          }
        }
      }
    }

    if (showAlert && errorMsg.length > 0) {
      this.setState({ errorMsg, showModal: true });
    }
    this.setState({ validSubmit });
    return isValid;
  }

  handleSubmitType(type) {
    if (type === 'save') {
      this.setState({
        typeOfSubmit: 'save'
      });
    } else if (type === 'saveQuote') {
      this.setState({
        typeOfSubmit: 'saveQuote'
      });
    }
  }

  render() {
    if (this.state.isLoading) {
      return (
        <ProgressBar />
      )
    }

    return (
      <div>
      {this.state.showModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              this.state.errorMsg.map((errorMsg) => {
                return <div>{errorMsg}</div>
              })
            }
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>OK</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}

        <h3 className="ebaoUtil__HeaderTwo">New Quotation - SmartDrive Private Car</h3>
        <ul className="ebaoUtil__Remarks">
          <li>* Mandatory for New Quotation</li>
        </ul>
        <Form horizontal onSubmit={this.handleSave}>
           <div className="ebaoUtil__Form-100">
              <RequestInfo
                requestInfo={this.state.pv.requestInfo}
                handleChangeRequestInfo={this.handleChangeRequestInfo}
                handleGetAgentName={this.handleGetAgentName}
                handleChangeAgentCode={this.handleChangeAgentCode}
                role={this.state.role}
                insuredNameRequired={false}
              />
              <CustomerContactInfo
                custContactInfo={this.state.pv.custContactInfo}
                handleChangeCustContactInfo={this.handleChangeCustContactInfo}
              />
              <ParticularOfVehicle
                particularOfVehicle={this.state.pv.particularOfVehicle}
                handleChangeParticularOfVehicle={this.handleChangeParticularOfVehicle}
                option={this.state.option}
                calculation={this.calculator}
                validation={this.validationOnSubmit}
              />
              <ParticularOfMainDriver
                particularOfMainDriver={this.state.pv.particularOfMainDriver}
                handleChangeParticularOfMainDriver={this.handleChangeParticularOfMainDriver}
                calculation={this.calculator}
                validation={this.validationOnSubmit}
              />
              {Array(this.state.count)
                .fill(1)
                .map((el, index) => {
                  const additionalDriveTitle = `Particular of Additional Driver ${index + 1}`;
                  const tmp = this.state.pv.particularOfAdditionalDriver[index];
                  const counter = index;
                  return <ParticularOfAdditionalDriver
                    key={counter}
                    title={additionalDriveTitle}
                    particularOfAdditionalDriver={tmp}
                    handleChangeParticularOfAdditionalDriver={this.handleChangeParticularOfAdditionalDriver}
                    calculation={this.calculator}
                    validation={this.validationOnSubmit}
                  />
                })
              }
              <div className="ebaoUtil_Float-Right">
                {this.state.count < 3 && this.state.isValidCreateDriver ?
                  <button className="btn btn-axa" onClick={this.createDriver} >Add Addtional Driver</button> :
                  <button className="btn btn-axa" onClick={this.createDriver} disabled>Add Additional Driver</button>
                }
                {' '}
                {this.state.count <= 0 ?
                  <button className="btn btn-axa" onClick={this.removeDriver} disabled >Remove</button> :
                  <button className="btn btn-axa" onClick={this.removeDriver} >Remove</button>
                }
              </div>

              <NcdEntitlementSumInsuredSection
                particularOfMainDriver={this.state.pv.particularOfMainDriver}
                handleChangeParticularOfMainDriver={this.handleChangeParticularOfMainDriver}
                validation={this.validationOnSubmit}
              />
              <CoverageInformation
                coverageInfo={this.state.pv.coverageInfo}
                handleChangeCoverageInfoPreviousFrom={this.handleChangeCoverageInfoPreviousFrom}
                handleChangeCoverageInfoPreviousTo={this.handleChangeCoverageInfoPreviousTo}
              />
              <CoverageTypeInfo
                mainCoverType={this.state.pv.coverageInfo.mainCoverType}
                handleChangeMainCoverageType={this.handleChangeMainCoverageType}
              />
              <UnderwritingQuestion
                underwritingQuestion={this.state.pv.underwritingQuestion}
                handleChangeUnderwritingQuestion={this.handleChangeUnderwritingQuestion}
              />
              <QuoteSummary
                grossPremium={this.state.pv.grossPremium}
                netPremium={this.state.pv.netPremium}
                mib={this.state.pv.mib}
                levy={this.state.pv.levy}
                premiumPayable={this.state.pv.premiumPayable}
              />
              <FormGroup controlId="buttonGroup">
                <div className="ebaoUtil__ButtonGroup-70">
                  {(this.state.validSubmit && this.state.additionalDriverValidSubmit && this.state.mainDriverValidSubmit) ?
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('save')} id="save">Save</button> :
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('save')} id="save" disabled>Save</button>
                  }{' '}
                  {(this.state.validSubmit && this.state.additionalDriverValidSubmit && this.state.mainDriverValidSubmit) ?
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('saveQuote')} id="saveQuote">Save & Quote</button> :
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('saveQuote')} id="saveQuote" disabled>Save & Quote</button>
                  }{' '}

                  <button className="btn btn-axa" onClick={this.handleClick} type="button">Exit</button>
                </div>
              </FormGroup>
           </div>
           </Form>
      </div>

    )
  }
}

PVForm.propTypes = {
  location: {
    state: {
      isAgree: PropTypes.bool
    }
  }
};

export default PVForm;



// WEBPACK FOOTER //
// ./src/app/pages/PVForm.js